/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M1.7778 22.5a.2778.2778 0 1 0 0-.5556.2778.2778 0 0 0 0 .5556ZM.8888.8889c0-.491.398-.8889.889-.8889C14.0508 0 24 9.9492 24 22.2222a.889.889 0 0 1-1.7778 0c0-11.2911-9.1533-20.4444-20.4444-20.4444a.8889.8889 0 0 1-.889-.889Zm.889 9.7778a.8888.8888 0 1 0 0 1.7777c5.4001 0 9.7778 4.3777 9.7778 9.7778a.8888.8888 0 1 0 1.7777 0c0-6.3819-5.1736-11.5555-11.5555-11.5555Zm0 13.3333c.9818 0 1.7778-.7959 1.7778-1.7778 0-.9818-.796-1.7778-1.7778-1.7778-.9819 0-1.7778.796-1.7778 1.7778C0 23.2041.796 24 1.7778 24Z"
    clipRule="evenodd"
  />,
  'Subscribe'
);
